export var PositionType;
(function (PositionType) {
    PositionType[PositionType["HTML5"] = 0] = "HTML5";
    PositionType[PositionType["IP"] = 1] = "IP";
    PositionType[PositionType["DEFAULT"] = 2] = "DEFAULT";
    PositionType[PositionType["FIXED"] = 3] = "FIXED";
})(PositionType || (PositionType = {}));
